import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import classNames from "classnames";
import { getClassNameFactory } from "../../utilities/classNames";

var FacetFilter = /*#__PURE__*/function (_Component) {
  _inherits(FacetFilter, _Component);

  var _super = _createSuper(FacetFilter);

  function FacetFilter(props) {
    var _this;

    _classCallCheck(this, FacetFilter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getClassName", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleOptionClick", function (optionId) {
      if (_this.props.handleOptionChange) {
        _this.props.handleOptionChange(_this.props.categoryId, optionId);
      }
    });

    _this.getClassName = getClassNameFactory(FacetFilter.displayName);
    return _this;
  }

  _createClass(FacetFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          categoryTitle = _this$props.categoryTitle,
          initialOptions = _this$props.initialOptions,
          propsClassName = _this$props.className;
      var currentOptions = initialOptions || [];
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(this.getClassName(), propsClassName),
        "data-testid": "facet-filter"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "divider"
        })
      }), categoryTitle && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "title"
        }),
        "data-testid": "facet-filter-category-title"
      }, categoryTitle), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "option-container"
        })
      }, currentOptions.map(function (option) {
        return /*#__PURE__*/React.createElement("div", {
          key: option.id,
          className: _this2.getClassName({
            descendantName: "option-item"
          }),
          "data-testid": "facet-filter-option-item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          className: _this2.getClassName({
            descendantName: "checkbox"
          }),
          onChange: function onChange(e) {
            return _this2.handleOptionClick(e.target.id);
          },
          id: option.id,
          name: option.label,
          "aria-label": categoryTitle,
          role: "checkbox",
          checked: option.selected,
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter" || e.key === " ") {
              _this2.handleOptionClick(option.id);
            }
          }
        }), /*#__PURE__*/React.createElement("span", {
          className: _this2.getClassName({
            descendantName: "option-label"
          })
        }, option.label));
      })));
    }
  }]);

  return FacetFilter;
}(Component);

_defineProperty(FacetFilter, "displayName", "FacetFilter");

_defineProperty(FacetFilter, "defaultProps", {
  categoryTitle: "Filter Options",
  initialOptions: [],
  handleOptionChange: function handleOptionChange() {},
  className: ""
});

export default FacetFilter;